import React, { useEffect, useState } from "react";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import QMark from "../../../../../assets/MainPage/questionMark.png";
import TextAreaIcon from "../../../../../assets/MainPage/textalignLeft.png";
import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";

import { useForm } from "react-hook-form";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import useLocales from "../../../../../hooks/useLocales";
import i18nForComponent from "../../../../../locales/component/i18nForComponent";
import { ReactComponent as DownArrow } from "../../../../../assets/settingPage/arrow-down.svg";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";
import { ReactComponent as MessageQuestion } from "../../../../../assets/MainPage/addBlock/faqBlock/message-question.svg";
import { ReactComponent as MessageQuestionDark } from "../../../../../assets/MainPage/addBlock/faqBlock/message-question-dark.svg";
import { ReactComponent as Frame } from "../../../../../assets/MainPage/addBlock/faqBlock/Frame.svg";
import { ReactComponent as FrameDark } from "../../../../../assets/MainPage/addBlock/faqBlock/Frame-Dark.svg";

import { I18nextProvider } from "react-i18next";
import { useSelector } from "react-redux";

// This Form component is responsible for add and edit FAQ Block

const FAQForm = ({
  formType,
  submitHandlerParent,
  isLoading,
  handleDelete,
  preHeaderData,
}) => {
  const { allLangs, tComponent, handleLanguageChange } = useLocales();
  const { darkMode } = useSelector((state) => state.theme);

  const { setActiveMainPageNav } = useStateContext();

  const [selectReporterTypeDropDown, setSelectReporterTypeDropDown] =
    useState(false);
  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm();

  useEffect(() => {
    if (preHeaderData?.coloum_value) {
      const values = preHeaderData?.coloum_value?.[0];
      setValue("question", values?.title);
      setValue("answer", values?.description);
      setSelectedLang(preHeaderData?.language);
      const matchedLang = allLangs?.find(
        (lang) => lang.value === preHeaderData?.language
      );
      const shouldSetLang = matchedLang?.label;
      setSelectedReporterType(shouldSetLang);
      handleLanguageChange(preHeaderData?.language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preHeaderData]);

  useEffect(() => {
    if (selectedLang) {
      handleLanguageChange(selectedLang);
    }
  }, [selectedLang]);

  const state = {
    title_one: "",
    description_one: "",
    columnName: "faq",
    coloum_type: "faq",
    language: "en",
  };

  const submitHandler = async (data) => {
    state.title_one = data.question;
    state.description_one = data.answer;
    state.language = selectedLang;
    submitHandlerParent(state);
  };

  const deleteHandler = async (data) => {
    if (formType === "add") {
      reset();
    } else {
      handleDelete(data);
    }
  };

  const handleChangeLang = (newLang) => {
    handleLanguageChange(newLang);
  };

  return (
    <I18nextProvider i18n={i18nForComponent}>
      <>
        <div
          className="sm:mt-7 md:px-0 mt-10 mb-6 px-6"
          style={{
            direction: selectedLang === "ar" ? "rtl" : "ltr",
          }}
        >
          <div className="border rounded-lg bg-light_bg_v5 p-[25px] dark:bg-dark-secondary dark:border-color_dark">
            <form onSubmit={handleSubmit(submitHandler)}>
              <div className="flex justify-between items-center mb-[20px] sm:mb-[25px]">
                <p className="text-small2_b sm:text-small1_bold text-heading_color dark:text-color_v1_dark uppercase">
                  {formType === "edit" && tComponent(`faq.${formType}`)}
                  {formType === "add" && tComponent(`faq.${formType}`)}
                  &nbsp;
                  {tComponent("faq.faq")}
                </p>
                {formType === "add" && (
                  <div className="flex items-center justify-center">
                    <div className="relative w-[115px] sm:w-[145px]">
                      <div
                        onClick={() => {
                          setSelectReporterTypeDropDown(
                            !selectReporterTypeDropDown
                          );
                        }}
                        className={`bg-light_bg_v4 capitalize p-[13px] text-small2 lg:text-body_copy2 rounded-md w-full flex justify-between items-center cursor-pointer`}
                      >
                        {selectedReporterType
                          ? selectedReporterType
                          : tComponent("faq.select_lang")}
                        <DownArrow />
                      </div>
                      {selectReporterTypeDropDown && (
                        <div className="absolute top-14 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5  rounded-lg border flex flex-col max-h-40 overflow-y-auto">
                          {allLangs?.map((item, i) => {
                            return (
                              <div
                                key={i}
                                onClick={() => {
                                  setSelectedLang(item.value); // Set selected language code
                                  setSelectedReporterType(item?.label);
                                  setSelectReporterTypeDropDown(false);
                                  handleChangeLang(item?.value);
                                }}
                                className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
                              >
                                {item.label}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {formType === "edit" && (
                  <div
                    className={`w-[100px] bg-light_bg_v4 capitalize p-[10px] text-small2 lg:text-body_copy2 rounded-md flex justify-center items-center`}
                  >
                    {selectedReporterType ? selectedReporterType : "English"}
                  </div>
                )}
              </div>
              <div className="mt-[20px] sm:mt-[25px]">
                <div>
                  <div className="mt-3 relative">
                    <div className="absolute inset-y-0 h-full sm:ps-[14px] ps-[16px] flex justify-center items-center">
                      {darkMode ? <MessageQuestionDark /> : <MessageQuestion />}
                    </div>
                    <input
                      type="text"
                      id="heading"
                      {...register("question", {
                        required: tComponent("faq.question_required"),
                      })}
                      className={`rounded-lg border bg-light_bg_v5 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[34px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark
                    ${
                      errors?.question
                        ? "border-state_color_error dark:bg-dark-secondary"
                        : "border-light_bg_v2 focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                    } `}
                      placeholder={tComponent("faq.enter_question")}
                    />
                  </div>
                  {errors?.question && (
                    <small className="text-state_color_error text-small3">
                      {errors?.question?.message}
                    </small>
                  )}
                  <div className="mt-[5px] sm:mt-[10px] relative">
                    <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center pt-[13px] sm:pt-[11px] items-start">
                      {darkMode ? <FrameDark /> : <Frame />}
                    </div>
                    <textarea
                      id="message"
                      rows="4"
                      {...register("answer", {
                        required: tComponent("faq.answer_required"),
                      })}
                      className={`rounded-lg resize-none border bg-light_bg_v5 p-[13px] sm:p-[11px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0  focus:placeholder:text-heading_color block w-full dark:bg-dark-secondary dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                        errors?.answer
                          ? "border-state_color_error dark:bg-dark-secondary"
                          : "border-light_bg_v2 focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color"
                      }`}
                      placeholder={tComponent("faq.enter_answer")}
                    ></textarea>
                  </div>
                  {errors?.answer && (
                    <small className="text-state_color_error text-small3">
                      {errors?.answer?.message}
                    </small>
                  )}
                </div>
              </div>
              <div className="flex mt-[26px] items-center justify-end">
                <button
                  type="button"
                  onClick={() => deleteHandler()}
                  className="flex justify-center items-center"
                >
                  {darkMode ? <TrashIconDark /> : <TrashIcon />}
                  <p className="ps-1.5 pt-1 text-small3_b gray-700 text-heading_color dark:text-color_v1_dark">
                    {tComponent("faq.delete_cap")}
                  </p>
                </button>

                <ExtraSmallFilledButton
                  name={`${tComponent("faq.save_cap")}`}
                  buttonType={"submit"}
                  isLoading={isLoading}
                  classes={"ms-3"}
                />
              </div>
            </form>
          </div>
        </div>
      </>
    </I18nextProvider>
  );
};

export default FAQForm;
